import { whiskyBrands } from "./whisky_brands";

const whiskyBrandsKeys = Object.keys(whiskyBrands);
const whiskyBrandsLabels = Object.values(whiskyBrands);

const contentUrl = {
  1: "https://www.themacallan.com/experience-the-macallan",
  2: "https://www.themacallan.com/distil-your-world",
  3: "https://www.themacallan.com/travel-retail-exclusives",
  4: "https://www.themacallan.com/whisky/single-malts/limited-releases/distil-your-world/distil-your-world-new-york",
  5: "https://www.themacallan.com/the-macallan-gift-guide",
  6: "https://www.themacallan.com/knowledge/education/mastering-whisky-types-of-whisky",
  7: "https://www.themacallan.com/inside-the-macallan/serves/boulevardier",
  8: "https://www.themacallan.com/explore-our-single-malts",
  9: "https://www.themacallan.com/distillery/book-experiences",
  10: "https://www.themacallan.com/knowledge/glossary",
  11: "https://www.themacallan.com/inside-the-macallan/our-process/an-alternative-path-setting-the-flavour-standard",
  12: "https://www.themacallan.com/making-of-the-macallan",
  13: "https://www.themacallan.com/inside-the-macallan/our-process/distinction-in-the-distillation",
  14: "https://www.themacallan.com/inside-the-macallan/our-process",
  15: "https://www.themacallan.com/inside-the-macallan/our-history/the-laird-of-easter-elchies-estate",
  16: "https://www.themacallan.com/the-macallan-exceptional-single-cask",
  17: "https://www.themacallan.com/knowledge/education/mastering-whisky-ice-or-no-ice",
  18: "https://www.themacallan.com/inside-the-macallan/our-process/part-1-time-wisdom-and-wood-the-story-of-the-macallan-cask",
  19: "https://www.themacallan.com/inside-the-macallan/our-history/back-to-our-roots-macallan-the-malt-part-2",
  20: "https://www.themacallan.com/knowledge/mastering-whisky-guidance-for-storing-your-whisky",
  21: "https://www.themacallan.com/inside-the-macallan/sustainability/evergreen-roofscape",
  22: "https://www.themacallan.com/inside-the-macallan/serves/old-fashioned",
  23: "https://www.themacallan.com/inside-the-macallan/our-whisky/the-passing-of-time-our-fine-rare-collection",
  24: "https://www.themacallan.com/distillery",
  25: "https://www.themacallan.com/experience-the-macallan/the-distillery-bar",
  26: "https://www.themacallan.com/the-macallan-in-lalique-glass",
  27: "https://www.themacallan.com/the-macallan-boutiques",
  28: "https://www.themacallan.com/shop",
  // 29: "https://www.themacallan.com/knowledge/whisky-sour",
  30: "https://www.themacallan.com/inside-the-macallan/our-whisky/inspiration-behind-a-1967-single-malt",
  31: "https://www.themacallan.com/inside-the-macallan/our-history",
  32: "https://www.themacallan.com/inside-the-macallan/our-history/a-legacy-in-the-making-the-macallan-1926-60-years-old",
  33: "https://www.themacallan.com/inside-the-macallan/our-process/macallan-whisky-mastery-team",
  34: "https://www.themacallan.com/inside-the-macallan/our-history/foundations-stories-that-have-shaped-the-macallan",
  35: "https://www.themacallan.com/inside-the-macallan/our-history/a-study-in-red",
  36: "https://www.themacallan.com/inside-the-macallan/partnerships",
  37: "https://www.themacallan.com/edition-no-6-fishing-experience",
  // 38: "https://www.themacallan.com/conversations/the-roca-brothers",
  39: "https://www.themacallan.com/evening-dining-experience",
  40: "https://www.themacallan.com/distil-your-world/flavour-and-sustainability-with-asma-khan",
  41: "https://www.themacallan.com/distillery/elchies-brasserie",
  42: "https://www.themacallan.com/inside-the-macallan/collaborations/behind-the-home-collection-the-distillery",
  // 43: "https://www.themacallan.com/inside-the-macallan/collaborations/in-collaboration-with-andrew-davidson",
  44: "https://www.themacallan.com/inside-the-macallan/our-whisky/a-prism-into-the-world-of-the-macallan",
  45: "https://www.themacallan.com/inside-the-macallan/collaborations/in-collaboration-with-mogwai",
  // 46: "https://www.themacallan.com/conversations/dylan-jones",
  // 47: "https://www.themacallan.com/conversations/mark-hogarth",
  48: "https://www.themacallan.com/inside-the-macallan/our-whisky/story-behind-the-james-bond-60th-anniversary-release/",
  49: "https://www.themacallan.com/single-malts/limited-releases/the-macallan-horizon-and-bentley",
  // 50: "https://www.themacallan.com/inside-the-macallan/collaborations/in-collaboration-with-laura-winningham",
  51: "https://www.themacallan.com/inside-the-macallan/sustainability",
  52: "https://www.themacallan.com/conversations/jonathan-crockett",
  53: "https://www.themacallan.com/conversations",
  54: "https://www.themacallan.com/make-the-call/art-and-science-of-decision-making",
  55: "https://www.themacallan.com/inside-the-macallan/our-whisky/a-guide-to-speyside-scotland",
  56: "https://www.themacallan.com/experience-the-macallan/the-macallan-in-paradiso",
  57: "https://www.themacallan.com/inside-the-macallan/our-whisky/the-enduring-legacy-of-the-reach",
  58: "https://www.themacallan.com/the-macallan-estate-pioneers-experience",
  59: "https://www.themacallan.com/about",
  60: "https://www.themacallan.com/inside-the-macallan/our-history/a-dream-of-old",
  62: "https://www.themacallan.com/en/inside-the-macallan/serves/the-cobbler",
  63: "https://www.themacallan.com/en/the-spirit-of-1926",
};

export const surveyModel = (t) => {
  if (typeof t === "undefined") t = (text) => text;
  return {
    triggers: [
      {
        type: "runexpression",
        expression: "{no_other_city} notempty",
        runExpression: "clearInput('other_city')",
      },
      {
        type: "setvalue",
        expression: "{other_city} notempty",
        setToName: "no_other_city",
        setValue: "",
      },
      {
        type: "runexpression",
        expression: "{whisky_macallan_only} notempty",
        runExpression: "clearInput('whisky_brands')",
      },
      {
        type: "setvalue",
        expression: "{whisky_brands} notempty",
        setToName: "whisky_macallan_only",
        setValue: "",
      },
      {
        type: "runexpression",
        expression: "{no_macallan_rare} notempty",
        runExpression: "clearInput('macallan_rare')",
      },
      {
        type: "setvalue",
        expression: "{macallan_rare} notempty",
        setToName: "no_macallan_rare",
        setValue: "",
      },
      {
        type: "runexpression",
        expression: "{no_experiences} notempty",
        runExpression: "clearInput('macallan_which_experiences_future')",
      },
      {
        type: "setvalue",
        expression: "{macallan_which_experiences_future} notempty",
        setToName: "no_experiences",
        setValue: "",
      },
      {
        type: "runexpression",
        expression: "{no_macallan_own} notempty",
        runExpression: "clearInput('macallan_own')",
      },
      {
        type: "setvalue",
        expression: "{macallan_own} notempty",
        setToName: "no_macallan_own",
        setValue: "",
      },
      {
        type: "runexpression",
        expression: "{no_macallan_like_to_own} notempty",
        runExpression: "clearInput('macallan_like_to_own')",
      },
      {
        type: "setvalue",
        expression: "{macallan_like_to_own} notempty",
        setToName: "no_macallan_like_to_own",
        setValue: "",
      },
      {
        type: "runexpression",
        expression: "{no_macallan_bought} notempty",
        runExpression: "clearInput('macallan_bought')",
      },
      {
        type: "setvalue",
        expression: "{macallan_bought} notempty",
        setToName: "no_macallan_bought",
        setValue: "",
      },
    ],
    pages: [
      // Chapter 1
      {
        name: "q_1_1",
        chapter: 1,
        background: "C1-2b.png",
        preloadBackground: ["C1-3b.png"],
        crmId: "gender__dropdown_",
        elements: [
          {
            type: "radiogroup",
            name: "gender",
            title: t("survey.question_1_1.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            hasOther: true,
            otherPlaceHolder: t("survey.question_1_1.answer_other", {
              ns: "survey",
            }),
            otherText: t("survey.question_1_1.answer_other", { ns: "survey" }),
            choices: [
              t("survey.question_1_1.answer_1", { ns: "survey" }),
              t("survey.question_1_1.answer_2", { ns: "survey" }),
              t("survey.question_1_1.answer_3", { ns: "survey" }),
            ],
            crmId: ["female", "male", "not_specified", "other"],
            customCssClass: "options-2columns",
          },
        ],
      },
      // Google Places autocomplete fot two following questions
      {
        name: "q_1_2",
        chapter: 1,
        background: "C1-3b.png",
        preloadBackground: ["C1-4b.png"],
        crmId: "city",
        elements: [
          {
            name: "city",
            title: t("survey.question_1_2.title", { ns: "survey" }),
            description: t("survey.question_1_2.description", { ns: "survey" }),
            isRequired: true,
            type: "text",
          },
        ],
        recommendations: {
          all: [contentUrl[1]],
        },
      },
      {
        name: "q_1_3",
        chapter: 1,
        background: "C1-4b.png",
        preloadBackground: ["C2-2b.png"],
        crmId: "secondary_city",
        elements: [
          {
            name: "other_city",
            title: t("survey.question_1_3.title", { ns: "survey" }),
            description: t("survey.question_1_3.description", { ns: "survey" }),
            type: "text",
            requiredIf: "{no_other_city} empty",
          },
          {
            type: "html",
            html:
              "<span class='sv_q_radiogroup_or'><span class='sv_q_radiogroup_or_line'>" +
              t("survey.common.or", { ns: "survey" }) +
              "</span></span>",
          },
          {
            type: "radiogroup",
            name: "no_other_city",
            title: " ",
            titleLocation: "hidden",
            requiredIf: "{other_city} empty",
            colCount: 1,
            choices: [
              "1|" + t("survey.question_1_3.answer_other", { ns: "survey" }),
            ],
          },
        ],
        // recommendations related to the answer
        // Internal table includes multiple recommendations from one category. In that case only one url will be randomly selected in the inputAdapter component.
        recommendations: {
          LondonUK: [contentUrl[4]],
          all: [[contentUrl[3], contentUrl[1]], contentUrl[2]],
        },
      },
      // Chapter 2
      {
        name: "q_2_1",
        chapter: 2,
        background: "C2-2b.png",
        preloadBackground: ["C2-3b.png", "C2-4b.png"],
        crmId: "are_you_a_whisky_drinker_",
        disabledMarkForLater: true,
        cardinalities: {
          true: { N: 1 },
        },
        elements: [
          {
            type: "radiogroup",
            name: "whisky_drinker",
            title: t("survey.question_2_1.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            choices: [
              "1|" + t("survey.common.yes", { ns: "survey" }),
              "2|" + t("survey.common.no", { ns: "survey" }),
            ],
            crmId: [true, false],
            customCssClass: "options-2columns",
          },
        ],
      },
      {
        // visual radio button
        name: "q_2_3",
        visibleIf: "{whisky_drinker}='1'",
        chapter: 2,
        background: "C2-4b.png",
        preloadBackground: ["C2-5b.png"],
        crmId: "how_much_have_you_explored_the_world_of_whisky_",
        cardinalities: {
          connoisseur: { NE: 0 },
          wide_depth: { NE: 0 },
        },
        elements: [
          {
            type: "radiogroup",
            name: "whisky_explored",
            title: t("survey.question_2_3.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            hasOther: true,
            otherText: t("survey.common.other", { ns: "survey" }),
            otherPlaceHolder: t("survey.question_2_3.answer_other", {
              ns: "survey",
            }),
            choices: [
              `![Whisky](/survey-assets/Novice.svg)

*${t("survey.question_2_3.answer_1", { ns: "survey" })}*`,
              `![Whisky](/survey-assets/Connoisseur.svg)

*${t("survey.question_2_3.answer_2", { ns: "survey" })}*`,
              `![Whisky](/survey-assets/InDepth.svg)

*${t("survey.question_2_3.answer_3", { ns: "survey" })}*`,
            ],
            crmId: ["novice", "connoisseur", "wide_depth", "other"],
            customCssClass: "options-3columns hasIcon",
          },
        ],
        recommendations: {
          novice: [
            [contentUrl[8], contentUrl[5]],
            [contentUrl[6], contentUrl[14]],
            contentUrl[9],
            contentUrl[10],
          ],
          connoisseur: [
            [contentUrl[12], contentUrl[11], contentUrl[13]],
            contentUrl[9],
            [contentUrl[14], contentUrl[15]],
          ],
          wide_depth: [
            [contentUrl[23], contentUrl[16]],
            contentUrl[33],
            contentUrl[9],
          ],
        },
      },
      {
        // radio button with subtext?
        name: "q_2_4",
        visibleIf: "{whisky_drinker}='1'",
        chapter: 2,
        background: "C2-5b.png",
        preloadBackground: ["C2-6b.png"],
        crmId: "have_you_found_your_perfect_whisky_",
        cardinalities: {
          no_looking: { W: 1 },
          yes_settled: { SW: 1 },
          yes_developed: { NE: 1, SW: 1 },
        },
        elements: [
          {
            type: "radiogroup",
            name: "whisky_perfect",
            title: t("survey.question_2_4.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            choices: [
              t("survey.question_2_4.answer_1", { ns: "survey" }),
              t("survey.question_2_4.answer_2", { ns: "survey" }),
              t("survey.question_2_4.answer_3", { ns: "survey" }),
              t("survey.question_2_4.answer_4", { ns: "survey" }),
            ],
            crmId: [
              "no_developing",
              "no_looking",
              "yes_settled",
              "yes_developed",
            ],
            customCssClass: "options-2columns",
          },
        ],
        recommendations: {
          no_developing: [contentUrl[8], [contentUrl[12], contentUrl[11]]],
          no_looking: [contentUrl[8], [contentUrl[12], contentUrl[11]]],
        },
      },
      {
        // select2 tagbox
        name: "q_2_5",
        visibleIf: "{whisky_drinker}='1'",
        chapter: 2,
        background: "C2-6b.png",
        preloadBackground: ["C2-7b.png"],
        crmId: "go_to_whisky_brands_other_than_the_macallan",
        cardinalities: {
          not_applicable: { SW: 1, SE: 1 },
        },
        elements: [
          {
            name: "whisky_brands",
            title: t("survey.question_2_5.title", { ns: "survey" }),
            requiredIf: "{whisky_macallan_only} empty",
            type: "tagbox",
            choices: whiskyBrandsLabels,
            crmId: whiskyBrandsKeys,
          },
          {
            type: "html",
            html:
              '<span class="sv_q_radiogroup_or"><span class="sv_q_radiogroup_or_line">' +
              t("survey.common.or", { ns: "survey" }) +
              "</span></span>",
          },
          {
            type: "radiogroup",
            name: "whisky_macallan_only",
            title: " ",
            titleLocation: "hidden",
            requiredIf: "{whisky_brands} empty",
            colCount: 1,
            choices: [
              "1|" + t("survey.question_2_5.answer_other", { ns: "survey" }),
            ],
            crmId: ["not_applicable"],
          },
        ],
      },
      {
        name: "ee1",
        isEasterEgg: true,
        visibleIf: "{whisky_drinker} = '1' and {whisky_macallan_only} = '1'",
        chapter: 2,
        elements: [
          {
            type: "html",
            name: "easter_egg_1",
            html:
              '<div class="easter-egg paragraph">' +
              t("survey.question_2_5.easter_egg", { ns: "survey" }) +
              "</div>",
          },
        ],
      },
      {
        name: "q_2_6",
        visibleIf: "{whisky_drinker}='1'",
        chapter: 2,
        background: "C2-7b.png",
        preloadBackground: ["C3-2b.png"],
        crmId: "do_people_ask_your_advice_about_whisky_",
        cardinalities: {
          yes: { E: 2, NE: 1 },
          sometimes: { E: 0 },
        },
        elements: [
          {
            type: "radiogroup",
            name: "whisky_advice",
            title: t("survey.question_2_6.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            choices: [
              "1|" + t("survey.common.yes", { ns: "survey" }),
              "2|" + t("survey.common.no", { ns: "survey" }),
              "3|" + t("survey.question_2_6.answer_3", { ns: "survey" }),
            ],
            crmId: ["yes", "no", "sometimes"],
            customCssClass: "options-2columns",
          },
        ],
        recommendations: {
          yes: [
            contentUrl[14],
            [contentUrl[18], contentUrl[19]],
            contentUrl[20],
          ],
          no: [
            contentUrl[14],
            [contentUrl[18], contentUrl[19]],
            contentUrl[20],
          ],
        },
      },
      {
        name: "q_2_2",
        visibleIf: "{whisky_drinker}='2'",
        chapter: 2,
        background: "C2-3b.png",
        preloadBackground: ["C3-2b.png"],
        crmId: "why_are_you_not_a_whisky_drinker_",
        elements: [
          {
            type: "radiogroup",
            name: "why_not_whisky_drinker",
            title: t("survey.question_2_2.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            choices: [
              t("survey.question_2_2.answer_1", { ns: "survey" }),
              t("survey.question_2_2.answer_2", { ns: "survey" }),
              t("survey.question_2_2.answer_3", { ns: "survey" }),
              t("survey.question_2_2.answer_4", { ns: "survey" }),
              t("survey.question_2_2.answer_5", { ns: "survey" }),
            ],
            crmId: ["never", "few", "palette", "occasional", "bourbon"],
            customCssClass: "options-2columns",
          },
        ],
        recommendations: {
          never: [contentUrl[6]],
          few: [[contentUrl[6], contentUrl[7]]],
          palette: [[contentUrl[6], contentUrl[7]]],
          occasional: [[contentUrl[6], contentUrl[7]]],
        },
      },
      // Chapter 3
      {
        name: "q_3_1",
        chapter: 3,
        background: "C3-2b.png",
        preloadBackground: ["C3-3b.png", "C3-7b.png"],
        crmId: "are_you_familiar_with_the_macallan_",
        disabledMarkForLater: true,
        cardinalities: {
          true: { N: 1 },
        },
        elements: [
          {
            type: "radiogroup",
            name: "macallan_tried",
            title: t("survey.question_3_1.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            choices: [
              "1|" + t("survey.common.yes", { ns: "survey" }),
              "2|" + t("survey.common.no", { ns: "survey" }),
            ],
            crmId: [true, false],
            customCssClass: "options-2columns",
          },
        ],
        recommendations: {
          false: [
            [contentUrl[8], contentUrl[5]],
            [contentUrl[12], contentUrl[11]],
            contentUrl[9],
            [contentUrl[17], contentUrl[18]],
          ],
        },
      },
      {
        name: "q_3_2",
        visibleIf: "{macallan_tried}='1'",
        chapter: 3,
        background: "C3-3b.png",
        preloadBackground: ["C3-4b.png"],
        crmId: "what_initially_intrigued_you_to_taste_the_macallan_",
        elements: [
          {
            type: "radiogroup",
            name: "macallan_intrigued",
            title: t("survey.question_3_2.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            choices: [
              "1|" + t("survey.question_3_2.answer_1", { ns: "survey" }),
              "2|" + t("survey.question_3_2.answer_2", { ns: "survey" }),
              "3|" + t("survey.question_3_2.answer_3", { ns: "survey" }),
              "4|" + t("survey.question_3_2.answer_4", { ns: "survey" }),
              "5|" + t("survey.question_3_2.answer_5", { ns: "survey" }),
              "6|" + t("survey.question_3_2.answer_6", { ns: "survey" }),
              "7|" + t("survey.question_3_2.answer_7", { ns: "survey" }),
              "8|" + t("survey.question_3_2.answer_8", { ns: "survey" }),
              "9|" + t("survey.question_3_2.answer_9", { ns: "survey" }),
              "10|" + t("survey.question_3_2.answer_10", { ns: "survey" }),
            ],
            crmId: [
              "speyside",
              "friend",
              "family",
              "colleague",
              "advert",
              "event",
              "curious",
              "gift",
              "work",
              "other",
            ],
            customCssClass: "options-inline",
          },
        ],
        recommendations: {
          speyside: [contentUrl[24]],
        },
      },
      {
        name: "ee_3_1_to_9",
        visibleIf: "{macallan_tried}='1' and {macallan_intrigued}!='10'",
        chapter: 3,
        isEasterEgg: true,
        elements: [
          {
            type: "html",
            name: "easter_egg_3_1",
            html:
              '<div class="easter-egg paragraph"><div class="easter-egg__answer tag">{macallan_intrigued}</div>' +
              t("survey.question_3_2.easter_egg_1", { ns: "survey" }) +
              "</div>",
            visibleIf: "{macallan_intrigued} = '1'",
          },
          {
            type: "html",
            name: "easter_egg_3_2",
            html:
              '<div class="easter-egg paragraph"><div class="easter-egg__answer tag">{macallan_intrigued}</div>' +
              t("survey.question_3_2.easter_egg_2", { ns: "survey" }) +
              "</div>",
            visibleIf: "{macallan_intrigued} = '2'",
          },
          {
            type: "html",
            name: "easter_egg_3_3",
            html:
              '<div class="easter-egg paragraph"><div class="easter-egg__answer tag">{macallan_intrigued}</div>' +
              t("survey.question_3_2.easter_egg_3", { ns: "survey" }) +
              "</div>",
            visibleIf: "{macallan_intrigued} = '3'",
          },
          {
            type: "html",
            name: "easter_egg_3_4",
            html:
              '<div class="easter-egg paragraph"><div class="easter-egg__answer tag">{macallan_intrigued}</div>' +
              t("survey.question_3_2.easter_egg_4", { ns: "survey" }) +
              "</div>",
            visibleIf: "{macallan_intrigued} = '4'",
          },
          {
            type: "html",
            name: "easter_egg_3_5",
            html:
              '<div class="easter-egg paragraph"><div class="easter-egg__answer tag">{macallan_intrigued}</div>' +
              t("survey.question_3_2.easter_egg_5", { ns: "survey" }) +
              "</div>",
            visibleIf: "{macallan_intrigued} = '5'",
          },
          {
            type: "html",
            name: "easter_egg_3_6",
            html:
              '<div class="easter-egg paragraph"><div class="easter-egg__answer tag">{macallan_intrigued}</div>' +
              t("survey.question_3_2.easter_egg_6", { ns: "survey" }) +
              "</div>",
            visibleIf: "{macallan_intrigued} = '6'",
          },
          {
            type: "html",
            name: "easter_egg_3_7",
            html:
              '<div class="easter-egg paragraph"><div class="easter-egg__answer tag">{macallan_intrigued}</div>' +
              t("survey.question_3_2.easter_egg_7", { ns: "survey" }) +
              "</div>",
            visibleIf: "{macallan_intrigued} = '7'",
          },
          {
            type: "html",
            name: "easter_egg_3_8",
            html:
              '<div class="easter-egg paragraph"><div class="easter-egg__answer tag">{macallan_intrigued}</div>' +
              t("survey.question_3_2.easter_egg_8", { ns: "survey" }) +
              "</div>",
            visibleIf: "{macallan_intrigued} = '8'",
          },
          {
            type: "html",
            name: "easter_egg_3_9",
            html:
              '<div class="easter-egg paragraph"><div class="easter-egg__answer tag">{macallan_intrigued}</div>' +
              t("survey.question_3_2.easter_egg_9", { ns: "survey" }) +
              "</div>",
            visibleIf: "{macallan_intrigued} = '9'",
          },
        ],
      },
      {
        name: "q_3_3",
        visibleIf: "{macallan_tried}='1'",
        chapter: 3,
        background: "C3-4b.png",
        preloadBackground: ["C3-5b.png"],
        crmId: "first_taste_of_macallan",

        cardinalities: {
          year_10: { SW: 1, NW: 1 },
          year_15: { SW: 1, NW: 1 },
          year_20: { SW: 1, NW: 1 },
          year_30: { SW: 1, NW: 1, NE: 1 },
          year_40: { SW: 1, NW: 1, NE: 1 },
          year_50: { SW: 1, NW: 1, NE: 1 },
          year_50_plus: { SW: 1, NW: 1, NE: 1 },
        },
        elements: [
          {
            type: "dropdown",
            renderAs: "select2",
            name: "macallan_how_long",
            title: t("survey.question_3_3.title", { ns: "survey" }),
            customCssClass: "select2-type-one",
            isRequired: true,
            choices: [
              t("survey.question_3_3.answer_1", { ns: "survey" }),
              t("survey.question_3_3.answer_2", { ns: "survey" }),
              t("survey.question_3_3.answer_3", { ns: "survey" }),
              t("survey.question_3_3.answer_4", { ns: "survey" }),
              t("survey.question_3_3.answer_5", { ns: "survey" }),
              t("survey.question_3_3.answer_6", { ns: "survey" }),
              t("survey.question_3_3.answer_7", { ns: "survey" }),
              t("survey.question_3_3.answer_8", { ns: "survey" }),
              t("survey.question_3_3.answer_9", { ns: "survey" }),
              t("survey.question_3_3.answer_10", { ns: "survey" }),
              t("survey.question_3_3.answer_11", { ns: "survey" }),
              t("survey.question_3_3.answer_12", { ns: "survey" }),
              t("survey.question_3_3.answer_13", { ns: "survey" }),
            ],
            crmId: [
              "month_3",
              "month_6",
              "month_9",
              "year_1",
              "year_2",
              "year_5",
              "year_10",
              "year_15",
              "year_20",
              "year_30",
              "year_40",
              "year_50",
              "year_50_plus",
            ],
          },
        ],
        recommendations: {
          year_10: [contentUrl[25], contentUrl[9]],
          year_15: [contentUrl[25], contentUrl[9]],
          year_20: [contentUrl[25], contentUrl[9]],
          year_30: [contentUrl[25], contentUrl[9]],
          year_40: [contentUrl[25], contentUrl[9]],
          year_50: [contentUrl[25], contentUrl[9]],
          year_50_plus: [contentUrl[25], contentUrl[9]],
        },
      },
      {
        // Select all that apply
        name: "q_3_4",
        visibleIf: "{macallan_tried}='1'",
        chapter: 3,
        background: "C3-5b.png",
        preloadBackground: ["C3-6b.png"],
        crmId: "why_do_you_tend_to_buy_the_macallan_",
        cardinalities: {
          bar_restaurant: { W: 1 },
          home: { N: 1 },
          occasion: { NW: 1, SE: 1 },
          collection: { S: 1 },
          investment: { S: 1 },
          gift: { E: 1 },
          job: { E: 1 },
        },
        elements: [
          {
            type: "checkbox",
            name: "macallan_why_buy",
            title: t("survey.question_3_4.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            choices: [
              t("survey.question_3_4.answer_1", { ns: "survey" }),
              t("survey.question_3_4.answer_2", { ns: "survey" }),
              t("survey.question_3_4.answer_3", { ns: "survey" }),
              t("survey.question_3_4.answer_4", { ns: "survey" }),
              t("survey.question_3_4.answer_5", { ns: "survey" }),
              t("survey.question_3_4.answer_6", { ns: "survey" }),
              t("survey.question_3_4.answer_7", { ns: "survey" }),
              t("survey.question_3_4.answer_8", { ns: "survey" }),
            ],
            crmId: [
              "bar_restaurant",
              "home",
              "occasion",
              "collection",
              "investment",
              "gift",
              "job",
              "other",
            ],
            customCssClass: "options-inline",
          },
        ],
        recommendations: {
          home: [contentUrl[26], contentUrl[20]],
          collection: [contentUrl[20]],
          investment: [contentUrl[20]],
          gift: [contentUrl[5]],
        },
      },
      {
        name: "q_3_5",
        visibleIf: "{macallan_tried}='1'",
        chapter: 3,
        background: "C3-6b.png",
        crmId: "how_do_you_enjoy_the_macallan_",
        cardinalities: {
          neat: { NW: 1, SW: 1 },
          ice: { SW: 1, NW: 1 },
          water: { SW: 1, NW: 1 },
          mixed: { W: 1, SW: 1 },
          mix: { W: 1 },
        },
        disabledMarkForLater: true,
        elements: [
          {
            type: "radiogroup",
            name: "macallan_how",
            title: t("survey.question_3_5.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            choices: [
              `1|![Whisky](/survey-assets/Neat.svg)

*${t("survey.question_3_5.answer_1", { ns: "survey" })}*`,
              `2|![Whisky](/survey-assets/WithIce.svg)

*${t("survey.question_3_5.answer_2", { ns: "survey" })}*`,
              `3|![Whisky](/survey-assets/Water.svg)

*${t("survey.question_3_5.answer_3", { ns: "survey" })}*`,
              `4|![Whisky](/survey-assets/Mixed.svg)

*${t("survey.question_3_5.answer_4", { ns: "survey" })}*`,
              "5|" + t("survey.question_3_5.answer_5", { ns: "survey" }),
            ],
            crmId: ["neat", "ice", "water", "mixed", "mix"],
            customCssClass: "options-4columns hasIcon hasIcon-grid-4",
          },
        ],
        recommendations: {
          neat: [contentUrl[7], contentUrl[25], contentUrl[17]],
          ice: [contentUrl[26], contentUrl[25], contentUrl[17]],
          mixed: [
            contentUrl[26],
            contentUrl[25],
            [contentUrl[22], contentUrl[62]],
          ],
          mix: [contentUrl[26], contentUrl[25], contentUrl[22]],
          water: [contentUrl[26], contentUrl[25], contentUrl[17]],

        },
      },
      {
        name: "q_3_5b",
        visibleIf: "{macallan_tried}='1' and {macallan_how}='4'",
        chapter: 3,
        background: "C3-6b.png",
        crmId: "drinking_style_preference",
        elements: [
          {
            type: "text",
            name: "macallan_enjoy_drink",
            title: t("survey.question_3_5b.title", { ns: "survey" }),
            isRequired: true,
          },
        ],
      },
      {
        name: "q_3_6",
        chapter: 3,
        background: "C3-7b.png",
        preloadBackground: ["C3-8b.png", "C3-17b.png"],
        crmId: "have_you_ever_bought_one_of_our_whiskies_",
        disabledMarkForLater: true,
        cardinalities: {
          investment: { S: 1 },
          enjoy: { N: 1 },
          gift: { E: 1, SE: 1 },
          job: { E: 1, NE: 1 },
        },
        elements: [
          {
            type: "checkbox",
            name: "macallan_bought",
            title: t("survey.question_3_6.title", { ns: "survey" }),
            requiredIf: "{no_macallan_bought} empty",
            colCount: 0,
            choices: [
              "1|" + t("survey.question_3_6.answer_1", { ns: "survey" }),
              "2|" + t("survey.question_3_6.answer_2", { ns: "survey" }),
              "3|" + t("survey.question_3_6.answer_3", { ns: "survey" }),
              "4|" + t("survey.question_3_6.answer_4", { ns: "survey" }),
            ],
            crmId: ["investment", "enjoy", "gift", "job"],
            customCssClass: "options-2columns",
          },
          {
            type: "html",
            html:
              "<span class='sv_q_radiogroup_or'><span class='sv_q_radiogroup_or_line'>" +
              t("survey.common.or", { ns: "survey" }) +
              "</span></span>",
          },
          {
            type: "radiogroup",
            name: "no_macallan_bought",
            title: " ",
            titleLocation: "hidden",
            requiredIf: "{macallan_bought} empty",
            colCount: 1,
            choices: [
              "1|" + t("survey.question_3_6.answer_5", { ns: "survey" }),
            ],
            crmId: ["no"],
          },
        ],
        recommendations: {
          investment: [contentUrl[20]],
          gift: [contentUrl[5]],
          no: [contentUrl[12]],
        },
      },
      {
        name: "q_3_7",
        visibleIf: "{no_macallan_bought} empty",
        chapter: 3,
        background: "C3-8b.png",
        preloadBackground: ["C3-9b.png"],
        crmId: "where_do_you_tend_to_buy_the_macallan_",
        cardinalities: {
          bar_restaurant: { W: 1 },
          store_specialist: { NE: 1 },
          macallan_contacts: { SE: 1 },
        },
        elements: [
          {
            type: "checkbox",
            name: "macallan_buy_where",
            title: t("survey.question_3_7.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            choices: [
              t("survey.question_3_7.answer_1", { ns: "survey" }),
              t("survey.question_3_7.answer_2", { ns: "survey" }),
              t("survey.question_3_7.answer_3", { ns: "survey" }),
              t("survey.question_3_7.answer_4", { ns: "survey" }),
              t("survey.question_3_7.answer_5", { ns: "survey" }),
              t("survey.question_3_7.answer_6", { ns: "survey" }),
              t("survey.question_3_7.answer_7", { ns: "survey" }),
              t("survey.question_3_7.answer_8", { ns: "survey" }),
              t("survey.question_3_7.answer_9", { ns: "survey" }),
              t("survey.question_3_7.answer_10", { ns: "survey" }),
              t("survey.question_3_7.answer_11", { ns: "survey" }),
            ],
            crmId: [
              "bar_restaurant",
              "supermarket",
              "store_specialist",
              "store_department",
              "online",
              "macallan_site",
              "airport",
              "gift",
              "macallan_contacts",
              "purchased_for_me",
              "other",
            ],
            customCssClass: "options-inline",
          },
        ],
        recommendations: {
          bar_restaurant: [contentUrl[62]],
          store_specialist: [contentUrl[27]],
          online: [contentUrl[28]],
        },
      },
      {
        name: "q_3_8",
        visibleIf: "{no_macallan_bought} empty",
        chapter: 3,
        background: "C3-9b.png",
        preloadBackground: ["C3-10b.png"],
        crmId: "how_often_do_you_buy_the_macallan_from_a_shop_",
        elements: [
          {
            type: "radiogroup",
            name: "macallan_buy_frequency",
            title: t("survey.question_3_8.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            hasOther: true,
            otherText: t("survey.common.other", { ns: "survey" }),
            otherPlaceHolder: t("survey.common.other_type_below", {
              ns: "survey",
            }),
            choices: [
              t("survey.common.weekly", { ns: "survey" }),
              t("survey.common.monthly", { ns: "survey" }),
              t("survey.common.few_year", { ns: "survey" }),
              t("survey.common.rarely", { ns: "survey" }),
            ],
            crmId: ["weekly", "monthly", "few_year", "rarely", "other"],
            customCssClass: "options-2columns",
          },
        ],
      },
      {
        name: "q_3_9",
        visibleIf: "{no_macallan_bought} empty",
        chapter: 3,
        background: "C3-10b.png",
        preloadBackground: ["C3-11b.png"],
        crmId: "how_often_do_you_choose_the_macallan_when_you_re_out_",
        cardinalities: {
          weekly: { N: 1, W: 1 },
          monthly: { N: 1 },
        },
        elements: [
          {
            type: "radiogroup",
            name: "macallan_out_frequency",
            title: t("survey.question_3_9.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            hasOther: true,
            otherText: t("survey.common.other", { ns: "survey" }),
            otherPlaceHolder: t("survey.common.other_type_below", {
              ns: "survey",
            }),
            choices: [
              t("survey.common.weekly", { ns: "survey" }),
              t("survey.common.monthly", { ns: "survey" }),
              t("survey.common.few_year", { ns: "survey" }),
              t("survey.common.rarely", { ns: "survey" }),
            ],
            crmId: ["weekly", "monthly", "few_year", "rarely", "other"],
            customCssClass: "options-2columns",
          },
        ],
      },
      {
        name: "q_3_10",
        visibleIf: "{no_macallan_bought} empty",
        chapter: 3,
        background: "C3-11b.png",
        preloadBackground: ["C3-12b.png"],
        crmId: "whiskies_experienced",
        cardinalities: {
          selection: [{ range: 1, cardinalities: { N: 1 } }], // selected number is greater or eqaul than "range"
        },
        elements: [
          {
            type: "checkbox", //visual or dropdown?
            name: "macallan_experienced",
            title: t("survey.question_3_10.title", { ns: "survey" }),
            /*description:
            "You'll have a chance to select some of our rarer whiskies in the next question",*/
            isRequired: true,
            colCount: 0,
            customCssClass: "options-smallgrid sv_q_checkbox-small",
            choices: [],
            isProductSelection: true,
          },
        ],
        recommendations: {
          all: [contentUrl[25]],
        },
      },
      /*
    {
      name: "q_3_11",
      visibleIf: "{macallan_bought}!='4'",
      chapter: 3,
      background: "C3-12b.png",
      preloadBackground: ["C3-13b.png"],
      crmId: "whiskies_experienced",
      elements: [
        {
          type: "tagbox", //autocomplete or dropdown?
          name: "macallan_rare",
          title: "Have you tried any of our rarer The Macallan whiskies?",
          requiredIf: "{no_macallan_rare} empty",
          colCount: 1,
          choices: rareMacallan,
          // TODO crmIDs of Macallan whiskies
        },
        {
          type: "html",
          html: '<span class="sv_q_radiogroup_or"><span class="sv_q_radiogroup_or_line">OR</span></span>',
        },
        {
          type: "radiogroup",
          name: "no_macallan_rare",
          title: " ",
          requiredIf: "{macallan_rare} empty",
          colCount: 1,
          choices: ["1|None"],
        },
      ],
    },
    */
      {
        name: "q_3_12",
        visibleIf: "{no_macallan_bought} empty",
        chapter: 3,
        background: "C3-13b.png",
        preloadBackground: ["C3-14b.png"],
        crmId: "whiskies_purchased_regularly",
        elements: [
          {
            type: "checkbox", //autocomplete or dropdown?
            //renderAs: "select2",
            name: "macallan_regularly",
            title: t("survey.question_3_12.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            maxSelectedChoices: 3,
            choices: [],
            customCssClass: "options-smallgrid sv_q_checkbox-small",
            isProductSelection: true,
          },
        ],
        recommendations: {
          all: [contentUrl[22], contentUrl[25]],
        },
      },
      {
        name: "q_3_13",
        visibleIf: "{no_macallan_bought} empty",
        chapter: 3,
        background: "C3-14b.png",
        preloadBackground: ["C3-15b.png"],
        crmId: "whiskies_owned",
        cardinalities: {
          // selected number is greater or eqaul than "range"
          selection: [
            { range: 11, cardinalities: { S: 2 } },
            { range: 7, cardinalities: { S: 1 } },
            { range: 4, cardinalities: { S: 0 } },
            { range: 1, cardinalities: { N: 1 } },
          ],
        },
        elements: [
          {
            type: "radiogroup",
            name: "no_macallan_own",
            title: " ",
            titleLocation: "hidden",
            requiredIf: "{macallan_own} empty",
            colCount: 1,
            choices: ["1|" + t("survey.common.none", { ns: "survey" })],
          },
          {
            type: "checkbox",
            name: "macallan_own",
            title: t("survey.question_3_13.title", { ns: "survey" }),
            requiredIf: "{no_macallan_own} empty",
            colCount: 0,
            customCssClass: "options-smallgrid sv_q_checkbox-small",
            choices: [],
          },
        ],
      },
      {
        name: "ee_3_10",
        isEasterEgg: true,
        visibleIf: "{no_macallan_bought} empty and {macallan_own.length} > 1",
        chapter: 3,
        elements: [
          {
            type: "html",
            name: "easter_egg_3_10",
            html:
              '<div class="easter-egg paragraph">' +
              t("survey.question_3_10.easter_egg", { ns: "survey" }) +
              "</div>",
          },
        ],
      },
      {
        name: "q_3_14",
        visibleIf: "{no_macallan_bought} empty",
        chapter: 3,
        background: "C3-15b.png",
        preloadBackground: ["C3-16b.png"],
        crmId: "desired_products",
        elements: [
          {
            type: "radiogroup",
            name: "no_macallan_like_to_own",
            title: " ",
            titleLocation: "hidden",
            requiredIf: "{macallan_like_to_own} empty",
            colCount: 1,
            choices: ["1|" + t("survey.common.none", { ns: "survey" })],
          },
          {
            type: "checkbox",
            name: "macallan_like_to_own",
            title: t("survey.question_3_14.title", { ns: "survey" }),
            requiredIf: "{no_macallan_like_to_own} empty",
            choices: [],
            customCssClass: "options-smallgrid sv_q_checkbox-small",
            colCount: 0,
            isProductSelection: true,
          },
        ],
        recommendations: {
          all: [contentUrl[20], contentUrl[30]],
        },
      },
      {
        name: "q_3_15",
        visibleIf: "{no_macallan_bought} empty",
        chapter: 3,
        background: "C3-16b.png",
        crmId: "why_do_you_choose_the_macallan_",
        cardinalities: {
          unparalleled: { NE: 2 },
          heritage: { NW: 2 },
          reputation: { SE: 2 },
          emotional: { W: 2 },
          settled: { SW: 2 },
          collector: { S: 2 },
          share_best: { E: 2 },
        },
        elements: [
          {
            type: "checkbox",
            name: "macallan_why",
            title: t("survey.question_3_15.title", { ns: "survey" }), // Select up to three
            isRequired: true,
            colCount: 0,
            maxSelectedChoices: 3,
            choices: [
              t("survey.question_3_15.answer_1", { ns: "survey" }),
              t("survey.question_3_15.answer_2", { ns: "survey" }),
              t("survey.question_3_15.answer_3", { ns: "survey" }),
              t("survey.question_3_15.answer_4", { ns: "survey" }),
              t("survey.question_3_15.answer_5", { ns: "survey" }),
              t("survey.question_3_15.answer_6", { ns: "survey" }),
              t("survey.question_3_15.answer_7", { ns: "survey" }),
              t("survey.question_3_15.answer_8", { ns: "survey" }),
            ],
            crmId: [
              "unparalleled",
              "heritage",
              "reputation",
              "emotional",
              "settled",
              "collector",
              "share_best",
              "other",
            ],
            customCssClass: "options-2columns",
          },
        ],
        recommendations: {
          heritage: [
            [contentUrl[31], contentUrl[34], contentUrl[35], contentUrl[63]],
          ],
          reputation: [contentUrl[32]],
          share_best: [contentUrl[59]],
          collector: [contentUrl[63]],
        },
      },
      {
        name: "q_3_16",
        chapter: 3,
        background: "C3-17b.png",
        preloadBackground: ["C3-18b.png", "C3-19b.png"],
        crmId: "have_you_ever_attended_one_of_our_experiences_",
        disabledMarkForLater: true,
        cardinalities: {
          true: { W: 1 },
        },
        elements: [
          {
            type: "radiogroup",
            name: "macallan_experiences",
            title: t("survey.question_3_16.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            choices: [
              "1|" + t("survey.common.yes", { ns: "survey" }),
              "2|" + t("survey.common.no", { ns: "survey" }),
            ],
            crmId: [true, false],
            customCssClass: "options-2columns",
          },
        ],
      },
      {
        name: "q_3_17",
        visibleIf: "{macallan_experiences}='1'",
        chapter: 3,
        background: "C3-18b.png",
        crmId: "experiences_attended",
        cardinalities: {
          selection: [
            { range: 3, cardinalities: { W: 3 } },
            { range: 1, cardinalities: { W: 1 } },
          ], // selected number is greater or eqaul than "range"
        },
        elements: [
          {
            type: "checkbox",
            name: "macallan_which_experiences",
            title: t("survey.question_3_17.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            choices: [
              t("survey.question_3_17.answer_1", { ns: "survey" }),
              t("survey.question_3_17.answer_2", { ns: "survey" }),
              t("survey.question_3_17.answer_3", { ns: "survey" }),
              t("survey.question_3_17.answer_4", { ns: "survey" }),
              t("survey.question_3_17.answer_5", { ns: "survey" }),
            ],
            crmId: ["estate", "tasting", "product_launch", "event", "other"],
            customCssClass: "options-2columns",
          },
        ],
      },
      {
        name: "q_3_18",
        chapter: 3,
        background: "C3-19b.png",
        preloadBackground: ["C3-20b.png"],
        crmId: "experiences_interested_in",
        cardinalities: {
          selection: [
            { range: 3, cardinalities: { W: 3 } },
            { range: 1, cardinalities: { W: 1 } },
          ], // selected number is greater or eqaul than "range"
        },
        elements: [
          {
            type: "checkbox",
            name: "macallan_which_experiences_future",
            title: t("survey.question_3_18.title", { ns: "survey" }),
            requiredIf: "{no_experiences} empty",
            isRequired: true,
            colCount: 0,
            choices: [
              t("survey.question_3_17.answer_1", { ns: "survey" }),
              t("survey.question_3_17.answer_2", { ns: "survey" }),
              t("survey.question_3_17.answer_3", { ns: "survey" }),
              t("survey.question_3_17.answer_4", { ns: "survey" }),
              t("survey.question_3_17.answer_5", { ns: "survey" }),
            ],
            crmId: ["estate", "tasting", "product_launch", "event", "other"],
            customCssClass: "options-2columns",
          },
          {
            type: "html",
            html:
              '<span class="sv_q_radiogroup_or"><span class="sv_q_radiogroup_or_line">' +
              t("survey.common.or", { ns: "survey" }) +
              "</span></span>",
          },
          {
            type: "radiogroup",
            name: "no_experiences",
            title: " ",
            titleLocation: "hidden",
            requiredIf: "{macallan_which_experiences_future} empty",
            colCount: 1,
            choices: ["1|" + t("survey.common.none", { ns: "survey" })],
          },
        ],
        recommendations: {
          estate: [contentUrl[24]],
          tasting: [contentUrl[24]],
          product_launch: [contentUrl[24]],
          event: [contentUrl[24]],
        },
      },
      {
        name: "q_3_19",
        chapter: 3,
        background: "C3-20b.png",
        preloadBackground: ["C3-21b.png", "C4-3b.png"],
        crmId: "have_you_ever_introduced_someone_to_the_macallan_",
        disabledMarkForLater: true,
        cardinalities: {
          true: { E: 1 },
        },
        elements: [
          {
            type: "radiogroup",
            name: "macallan_introduced_someone",
            title: t("survey.question_3_19.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            choices: [
              "1|" + t("survey.common.yes", { ns: "survey" }),
              "2|" + t("survey.common.no", { ns: "survey" }),
            ],
            crmId: [true, false],
            customCssClass: "options-2columns",
          },
        ],
        recommendations: {
          true: [contentUrl[63]],
      },
      },
      {
        name: "q_3_20",
        visibleIf: "{macallan_introduced_someone}='1'",
        chapter: 3,
        background: "C3-21b.png",
        preloadBackground: ["C3-22b.png"],
        crmId: "who_have_you_introduced_",
        cardinalities: {
          selection: [
            { range: 3, cardinalities: { E: 3 } },
            { range: 1, cardinalities: { E: 1 } },
          ], // selected number is greater or eqaul than "range"
        },
        elements: [
          {
            type: "checkbox",
            name: "macallan_introduced_who",
            title: t("survey.question_3_20.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            choices: [
              t("survey.question_3_20.answer_1", { ns: "survey" }),
              t("survey.question_3_20.answer_2", { ns: "survey" }),
              t("survey.question_3_20.answer_3", { ns: "survey" }),
              t("survey.question_3_20.answer_4", { ns: "survey" }),
              t("survey.question_3_20.answer_5", { ns: "survey" }),
              t("survey.question_3_20.answer_6", { ns: "survey" }),
              t("survey.question_3_20.answer_7", { ns: "survey" }),
            ],
            crmId: [
              "friend",
              "family",
              "colleagues",
              "serve_at_events",
              "take_to_events",
              "social_media",
              "other",
            ],
            customCssClass: "options-inline",
          },
        ],
      },
      {
        name: "q_3_21",
        visibleIf: "{macallan_introduced_someone}='1'",
        chapter: 3,
        background: "C3-22b.png",
        crmId: "what_makes_you_want_to_share_your_whisky_",
        cardinalities: {
          friends_family: { SE: 1 },
          best: { NE: 1 },
          passion: { E: 1 },
        },
        elements: [
          {
            type: "checkbox",
            name: "macallan_introduced_why",
            title: t("survey.question_3_21.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            choices: [
              t("survey.question_3_21.answer_1", { ns: "survey" }),
              t("survey.question_3_21.answer_2", { ns: "survey" }),
              t("survey.question_3_21.answer_3", { ns: "survey" }),
              t("survey.question_3_21.answer_4", { ns: "survey" }),
              t("survey.question_3_21.answer_5", { ns: "survey" }),
            ],
            crmId: ["friends_family", "best", "passion", "treat", "other"],
            customCssClass: "options-2columns",
          },
        ],
      },
      // Chapter 4
      {
        name: "q_4_1", // smaller buttons, a lot of options
        chapter: 4,
        background: "C4-2b.png",
        preloadBackground: ["C4-3b.png"],
        crmId: "interests",
        elements: [
          {
            type: "checkbox",
            name: "style_doing",
            title: t("survey.question_4_1.title", { ns: "survey" }),
            isRequired: true,
            colCount: 0,
            customCssClass: "options-smallgrid",
            maxSelectedChoices: 5,
            hasOther: true,
            otherText: t("survey.common.other", { ns: "survey" }),
            otherPlaceHolder: t("survey.common.other_type_below", {
              ns: "survey",
            }),
            choices: [
              t("survey.question_4_1.answer_1", { ns: "survey" }),
              t("survey.question_4_1.answer_2", { ns: "survey" }),
              t("survey.question_4_1.answer_3", { ns: "survey" }),
              t("survey.question_4_1.answer_4", { ns: "survey" }),
              t("survey.question_4_1.answer_5", { ns: "survey" }),
              t("survey.question_4_1.answer_6", { ns: "survey" }),
              t("survey.question_4_1.answer_7", { ns: "survey" }),
              t("survey.question_4_1.answer_8", { ns: "survey" }),
              t("survey.question_4_1.answer_9", { ns: "survey" }),
              t("survey.question_4_1.answer_10", { ns: "survey" }),
              t("survey.question_4_1.answer_11", { ns: "survey" }),
              t("survey.question_4_1.answer_12", { ns: "survey" }),
              t("survey.question_4_1.answer_13", { ns: "survey" }),
              t("survey.question_4_1.answer_14", { ns: "survey" }),
              t("survey.question_4_1.answer_15", { ns: "survey" }),
              t("survey.question_4_1.answer_16", { ns: "survey" }),
              t("survey.question_4_1.answer_17", { ns: "survey" }),
              t("survey.question_4_1.answer_18", { ns: "survey" }),
              t("survey.question_4_1.answer_19", { ns: "survey" }),
              t("survey.question_4_1.answer_20", { ns: "survey" }),
              t("survey.question_4_1.answer_21", { ns: "survey" }),
              t("survey.question_4_1.answer_22", { ns: "survey" }),
              t("survey.question_4_1.answer_23", { ns: "survey" }),
              t("survey.question_4_1.answer_24", { ns: "survey" }),
              t("survey.question_4_1.answer_25", { ns: "survey" }),
              t("survey.question_4_1.answer_26", { ns: "survey" }),
              t("survey.question_4_1.answer_27", { ns: "survey" }),
              t("survey.question_4_1.answer_28", { ns: "survey" }),
            ],
            crmId: [
              "travel",
              "nature",
              "new_experiences",
              "adventure",
              "attending_events",
              "music_listening",
              "music_playing",
              "concerts",
              "theatre",
              "sports",
              "health_wellness",
              "new_cuisines",
              "dining_fine",
              "dining_relaxed",
              "art_classical",
              "art_modern",
              "museums",
              "fashion",
              "jewellery",
              "cars",
              "yachts",
              "current_affairs",
              "philanthropy",
              "real_estate",
              "stock_market",
              "finance",
              "business",
              "entrepreneurship",
              "other",
            ],
          },
        ],
        recommendations: {
          sports: [contentUrl[37]],
          dining_fine: [contentUrl[39]],
          dining_relaxed: [contentUrl[41]],
          art_classical: [contentUrl[42]],
          art_modern: [contentUrl[44], contentUrl[42]],
          museums: [contentUrl[2]],
          fashion: [[contentUrl[44], contentUrl[48]]],
          jewellery: [contentUrl[44]],
          cars: [contentUrl[49]],
          yachts: [contentUrl[49]],
          philanthropy: [contentUrl[51]],
          finance: [contentUrl[53]],
          business: [[contentUrl[53], contentUrl[54]]],
          entrepreneurship: [[contentUrl[53], contentUrl[54]]],
          travel: [contentUrl[55], contentUrl[56]],
          nature: [contentUrl[51], contentUrl[21]],
          new_experiences: [contentUrl[9]],
          attending_events: [contentUrl[9]],
          music_listening: [contentUrl[45]],
          music_playing: [contentUrl[15]],
          concerts: [contentUrl[15]],
          theatre: [contentUrl[58]],
        },
      },
      {
        name: "q_4_2",
        chapter: 4,
        sliderType: "typeOne",
        background: "C4-3b.png",
        preloadBackground: ["C4-4b.png"],
        crmId: "i_prefer_spending_a_quiet_evening_at_home_to_going_out",
        cardinalities: {
          1: { W: 1 },
          5: { SW: 1 },
        },
        elements: [
          {
            type: "nouislider",
            name: "style_going_out",
            title: t("survey.question_4_2.title", { ns: "survey" }),
            description: t("survey.common.range_description", { ns: "survey" }),
            step: 1,
            rangeMin: 1,
            rangeMax: 5,
            crmId: [1, 2, 3, 4, 5],
          },
        ],
      },
      {
        name: "q_4_3",
        chapter: 4,
        background: "C4-4b.png",
        preloadBackground: ["C4-5b.png"],
        crmId: "i_like_to_stand_out_from_the_crowd",
        cardinalities: {
          1: { SW: 1 },
          5: { W: 1 },
        },
        elements: [
          {
            type: "nouislider",
            name: "style_stand_out",
            title: t("survey.question_4_3.title", { ns: "survey" }),
            description: t("survey.common.range_description", { ns: "survey" }),
            step: 1,
            rangeMin: 1,
            rangeMax: 5,
            crmId: [1, 2, 3, 4, 5],
          },
        ],
      },
      {
        name: "q_4_4",
        chapter: 4,
        background: "C4-5b.png",
        preloadBackground: ["C4-6b.png"],
        crmId: "for_me__owning_luxury_goods_is_a_symbol_of_success",
        cardinalities: {
          5: { SE: 1 },
        },
        elements: [
          {
            type: "nouislider",
            name: "style_success",
            title: t("survey.question_4_4.title", { ns: "survey" }),
            description: t("survey.common.range_description", { ns: "survey" }),
            step: 1,
            rangeMin: 1,
            rangeMax: 5,
            crmId: [1, 2, 3, 4, 5],
          },
        ],
      },
      {
        name: "q_4_5",
        chapter: 4,
        background: "C4-6b.png",
        preloadBackground: ["C4-7b.png"],
        crmId: "buying_luxury_spirits_is_a_symbol_of_success",
        cardinalities: {
          5: { NE: 1, S: 1 },
        },
        elements: [
          {
            type: "nouislider",
            name: "style_luxury_spirits",
            title: t("survey.question_4_5.title", { ns: "survey" }),
            description: t("survey.common.range_description", { ns: "survey" }),
            step: 1,
            rangeMin: 1,
            rangeMax: 5,
            crmId: [1, 2, 3, 4, 5],
          },
        ],
      },
      {
        name: "q_4_6",
        chapter: 4,
        background: "C4-7b.png",
        crmId:
          "if_a_product_or_brand_is_available_to_everyone_then_it_can_t_be_called_luxury",
        cardinalities: {
          5: { SE: 1, S: 1 },
        },
        elements: [
          {
            type: "nouislider",
            name: "style_everyone",
            title: t("survey.question_4_6.title", { ns: "survey" }),
            description: t("survey.common.range_description", { ns: "survey" }),
            step: 1,
            rangeMin: 1,
            rangeMax: 5,
            crmId: [1, 2, 3, 4, 5],
          },
        ],
      },
      // this is dummy page, because the last one has "Complete" button and we don't want it here
      {
        name: "last_page",
        isEasterEgg: true,
        chapter: 4,
        background: "Hero-1b.png",
        elements: [
          {
            type: "html",
            name: "last_page_q",
            html: "<div>dummy page</div>",
          },
        ],
      },
    ],
  };
};
